import { Box, Button, Card } from '@nimbus-ds/components';
import CreditCardForm from 'domains/Billing/Checkout/CheckoutUI/CreditCardForm';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

function CreditCardDataCardSkeleton() {
  const t = useTranslationBilling(
    'checkout.payWithCreditCard.creditCardDataCard',
  );

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Card>
        <Card.Header title={t('title')} />
        <Card.Body>
          <CreditCardForm.Skeleton />
        </Card.Body>
      </Card>

      <Box display="flex" flexDirection="row" justifyContent="flex-end">
        <Button.Skeleton />
      </Box>
    </Box>
  );
}

export default CreditCardDataCardSkeleton;
